import { useMutation } from 'react-query';

import { bulkDeleteTags as mutationFn } from 'api/endPoints/bulkDeleteTags';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationBulkTagsRemove = () => {
    return useMutation<string, QueryError, IBulkRemoveTagsPayload>((params) => mutationFn(params));
};

interface IBulkRemoveTagsPayload {
    uniqIdNotification: number;
    tagToRemoveList: {
        name: string;
    }[];
    filter: {
        filters: IFilter;
    };
    paging: {
        page: number;
        size: number;
    };
    withDetails: boolean;
}
